import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "font-size-18 font-bold" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mt-1" }, null, -1)
const _hoisted_4 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_5 = {
  key: 0,
  class: "flex mt-8"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-checkmark text-2xl" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-close text-2xl" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputArea = _resolveComponent("InputArea")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('applicationReason')), 1),
      _hoisted_3,
      (!_ctx.isDetail)
        ? _renderSlot(_ctx.$slots, "reason", { key: 0 }, () => [
            _createVNode(_component_InputArea, {
              placeholder: _ctx.placeholderReason,
              class: "mt-4",
              modelValue: _ctx.reasonInput,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.reasonInput = $event)),
              modelModifiers: { trim: true },
              required: "",
              validated: _ctx.validatedReason,
              errors: _ctx.errorsReason,
              "onUpdate:errors": _cache[2] || (_cache[2] = ($event: any) => (_ctx.errorsReason = $event)),
              "error-server": _ctx.errorsServerReason,
              onChange: _ctx.changeReason
            }, null, 8, ["placeholder", "modelValue", "validated", "errors", "error-server", "onChange"])
          ])
        : (_openBlock(), _createBlock("div", _hoisted_4, _toDisplayString(_ctx.modelValue), 1))
    ]),
    (!_ctx.isDetail)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode(_component_Button, {
            disabled: _ctx.reasonInput.toString().trim() === '' || !_ctx.isValid,
            class: "mr-4",
            onClick: _ctx.handleCreateApplication
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createTextVNode(_toDisplayString(_ctx.t('buttonApply')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_Button, {
            class: "font-normal",
            variant: "outline-primary",
            disabled: _ctx.applicationFormId,
            onClick: _ctx.handleCancel
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createTextVNode(_toDisplayString(_ctx.t('cancel')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}